export default {
    ROOT_URL:"/",
    COMPANY_URL:"/company_admin.html",
    SALARY_TALK:"薪资面议"
}
